import { render, staticRenderFns } from "./Template25.vue?vue&type=template&id=7440724c&scoped=true&"
import script from "./Template25.vue?vue&type=script&lang=js&"
export * from "./Template25.vue?vue&type=script&lang=js&"
import style0 from "./Template25.vue?vue&type=style&index=0&id=7440724c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440724c",
  null
  
)

export default component.exports